import type { SVGProps } from 'react';

const FailSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <circle cx={16} cy={16} r={10} fill="currentColor" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={2}
      d="m13 19 6-6M13 13l6 6"
    />
  </svg>
);
export default FailSvgIcon;
